export enum TechnicalReasonType {
  Yes = "yes",
  No = "no",
  Unsure = "unsure",
}
